import { create } from "zustand";
import type { TicketDepartment } from "../services/investor/ticketService";

/** What the question box or a quick chip already knows when the sheet opens. */
export interface RequestSeed {
  text?: string;
  department?: TicketDepartment;
  category?: string;
}

export interface CreatedRequest {
  ticketId: number;
  department: TicketDepartment;
}

/**
 * The "new request" sheet opens from many places: the support page, the
 * dashboard, the contact modal and a unit page, which hands over its unit.
 */
interface CreateRequestModalState {
  isVisible: boolean;
  unitId: number | null;
  seed: RequestSeed;
  /**
   * The request just sent, for the support page to confirm and flash. Kept in
   * the store because the sheet sends from anywhere and the page may mount
   * only after the navigation.
   */
  created: CreatedRequest | null;
  open: (unitId?: number | null, seed?: RequestSeed) => void;
  close: () => void;
  markCreated: (created: CreatedRequest) => void;
  consumeCreated: () => CreatedRequest | null;
}

const useCreateRequestModalStore = create<CreateRequestModalState>()((set, get) => ({
  isVisible: false,
  unitId: null,
  seed: {},
  created: null,
  open: (unitId = null, seed = {}) => set({ isVisible: true, unitId, seed }),
  close: () => set({ isVisible: false, unitId: null, seed: {} }),
  markCreated: (created) => set({ created }),
  consumeCreated: () => {
    const created = get().created;
    if (created) set({ created: null });
    return created;
  },
}));

export default useCreateRequestModalStore;
